













import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    props: {
        text: {
            type: String,
            default: ''
        }
    }
})
export default class Loading extends Vue {
    visible: boolean = true;
};
